<template>
    <div>
        <TableFilterButton @show-filter="toggleFilter"
                           @clear-filter="clearFilter"
                           :is-filter-applied="isFilterApplied"
        />
        <transition enter-active-class="animated bounceInRight" leave-active-class="animated bounceOutRight">
            <TableFilterBox v-show="isFilterShown"
                            :scheme-type="schemeType" :filter-refs="filterRefs"
                            @apply-filter="applyFilter"
                            ref="filters"
            >
                <slot></slot>
            </TableFilterBox>
        </transition>
    </div>
</template>

<script>
import TableFilterBox from "@/components/newFilter/TableFilterBox";
import TableFilterButton from "@/components/newFilter/TableFilterButton";

export default {
    components: {
        TableFilterButton,
        TableFilterBox
    },
    props: {
        schemeType: Number,
        filterRefs: Object,
    },
    data() {
        return {
            isFilterShown: false,
            isFilterApplied: false
        };
    },
    methods: {
        toggleFilter() {
            if (this.isFilterShown) {
                this.$refs.filters.applyFilter();
            } else {
                this.isFilterShown = true;
            }
        },
        applyFilter(filters) {
            this.isFilterShown = false;
            this.isFilterApplied = filters && filters.length > 0;
            this.$emit("apply-filter", filters);
        },
        clearFilter() {
            this.$refs.filters.clearFilter(true);
        }
    },
};
</script>